import { useState } from "react";
export const useDeleteDialog = () => {
  const [dialog, setDialog] = useState({
    isOpen: false,
    id: "",
  });

  const onCloseDelete = () => {
    setDialog({ isOpen: false, id: "" });
  };

  const onOpendelete = (id: string) => {
    setDialog({ isOpen: true, id });
  };

  return {
    isOpenDelete: dialog.isOpen,
    deleteId: dialog.id,
    onCloseDelete,
    onOpendelete,
  };
};
